import React, { useEffect } from 'react';
import moment from 'moment';
import { Grid, ButtonGroup, Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setlayoutLiveTracking } from '../../features/layout/layoutSlice';


const AssetDefaultFooter = ({ coreData, statusMeta }) => {

    const dispatch = useDispatch();
    useEffect(() => {
        const liveTrackingLayoutPayload = {
            sidebarWidthratio: 0.25,
            minFooter: 80,
        };
        dispatch(setlayoutLiveTracking(liveTrackingLayoutPayload));
        //console.log("re rendering");
    }, [dispatch]);

    //console.log("ore", coreData);
    return (
        <Grid
            container
            direction='row'
            justifyContent='flex-start'
            alignItems='center'
            alignContent="center"
            wrap='wrap'
            spacing={1}
            style={{
                marginLeft: '0px',
                marginBottom: '10px',
                width: '90vw',
            }}
        >
            <Grid item key="heartbeat">
                <ButtonGroup>
                    <Button
                        variant="contained"
                        style={{
                            backgroundColor: statusMeta.hbtage < 60 ? 'DodgerBlue' : 'Gray',
                            color: 'White',
                        }}
                        size="small"
                    >
                        Heartbeat
                    </Button>
                    <Button
                        variant="outlined"
                        size="small"
                        style={{
                            color: 'blueGray',
                        }}
                    >
                        <span>
                            <b>
                                {` ${moment(coreData.dt_server).format('D/M/YY h:mm:ss A')} `}
                            </b>
                        </span>
                    </Button>
                </ButtonGroup>
            </Grid>
            <Grid item key="location">
                <ButtonGroup>
                    <Button
                        variant="contained"
                        style={{
                            backgroundColor: statusMeta.locage < 30 ? 'DodgerBlue' : 'Gray',
                            color: 'White',
                        }}
                        size="small"
                    >
                        Location Data
                    </Button>
                    <Button
                        variant="outlined"
                        size="small"
                        style={{
                            color: 'blueGray',
                        }}
                    >
                        <span>
                            <b>
                                {` ${moment(coreData.dt_tracker).fromNow()} `}
                            </b>
                        </span>
                    </Button>
                </ButtonGroup>
            </Grid>
            <Grid item key="status">
                <ButtonGroup>
                    <Button variant="contained"
                        size="small"
                        style={{
                            backgroundColor: statusMeta.colorbg,
                            color: statusMeta.colorfg
                        }}
                    >
                        Status
                    </Button>
                    <Button
                        variant="outlined"
                        size="small"
                        style={{
                            color: 'blueGray',
                        }}
                    >
                        <span>
                            <b>
                                {` ${statusMeta.summaryStatus} (${statusMeta.status}) `}
                            </b>
                        </span>
                    </Button>
                </ButtonGroup>
            </Grid>


            <Grid item key="engine">
                <ButtonGroup>
                    <Button
                        variant="contained"
                        size="small"
                        style={{
                            backgroundColor: coreData.engine !== 0 && coreData.engine !== "0" ? statusMeta.colorbg : 'Gray',
                            color: 'White'
                        }}
                    >
                        Engine
                    </Button>

                    {
                        coreData.engine !== 0 && coreData.engine !== "0" ?

                            <Button variant="outlined" style={{
                                color: 'blueGray',
                            }} size="small">
                                <span>
                                    <b>
                                        {` ${"Running"}`}
                                    </b>
                                </span>
                            </Button>
                            :
                            <Button variant="outlined" style={{
                                color: 'blueGray',
                            }} size="small">
                                <span>
                                    <b>
                                        {` ${"Off"}`}
                                    </b>
                                </span>

                            </Button>


                    }
                </ButtonGroup>
            </Grid>
            {
                coreData.speed > 0 && statusMeta.locage >= 0 && statusMeta.locage < 5 &&
                <Grid item key="speed">
                    <ButtonGroup>
                        <Button
                            variant="contained"
                            size="small"
                            style={{
                                backgroundColor: statusMeta.colorbg,
                                color: statusMeta.colorfg
                            }}
                        >
                            Speed
                        </Button>
                        <Button
                            variant="outlined"
                            size="small"
                            style={{
                                color: 'blueGray',
                            }}
                        >
                            <span>
                                <b>
                                    {` ${coreData.speed} Km/h (${coreData.angle})`}
                                </b>
                            </span>
                        </Button>
                    </ButtonGroup>

                </Grid>
            }
            <Grid item key="odometer">
                <ButtonGroup>
                    <Button variant="contained" style={{
                        backgroundColor: statusMeta.locage < 30 ? 'DodgerBlue' : 'Gray',
                        color: 'White',
                    }} size="small">
                        Odometer
                    </Button>
                    <Button variant="outlined" style={{
                        color: 'blueGray',
                    }} size="small">
                        <span>
                            <b>
                                {` ${Math.round(coreData.odometer).toLocaleString('en-IN')} Km`}
                            </b>
                        </span>

                    </Button>
                </ButtonGroup>
            </Grid>



        </Grid>
    );
}

export default React.memo(AssetDefaultFooter);

